module.exports = __webpack_public_path__ + "img/logo-footer-02.f228b08d.jpg";